export default "__VITE_ASSET__C0Dxzw3L__"